import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import RoomItem from './Items/RoomItem';
import { changeIsSummaryOpened } from '../../model/configuratorSlice';
import SummaryPanel from '../Summary/SummaryPanel';
import DescriptionPanel from '../DescriptionPanel/DescriptionPanel';
import MainMenu from '../MainMenu/MainMenu';
import useWindowSize from '../../hooks/useWindowSize';
import SummaryPanelMobile from '../Summary/SummaryPanelMobile';
import { currencyFormatter } from '../../utils/currencyFormatter';
import { MobileWidth } from '../../model/constants';
import { TranslationUtility } from '../../utilities/TranslationUtility';

const RoomsPanel = () => {
  const {
 rooms, categories, totalPrice, legalSettings, isPublic, vat,
} = useSelector(state => state.configurator);
  const windowsSize = useWindowSize();
  const dispatch = useDispatch();

  const getCategoriesForRoom = (room) => {
    const roomCategories = [];

    room.categories.forEach((roomCategory) => {
      const roomCategoryItem = categories.filter(cat => cat.id === roomCategory.id)[0] || null;

      if (roomCategoryItem !== null && roomCategory.hideInMenu !== true) {
        roomCategories.push(roomCategoryItem);
      }
    });

    return roomCategories;
  };

  const isSmallScreen = () => windowsSize.width <= MobileWidth;


  return (
    <div className="rooms-panel">
      {/* <div className="divider-top" /> */}
      <div className="container-rooms" id="container-rooms">
        <div className="blank-space" />
        {rooms.map((room, index) => (
          <RoomItem
            id={room.id}
            name={TranslationUtility.GetFormattedMessageForRoomName(room)}
            nextRoomName={index < rooms.length - 1 ? rooms[index + 1].name : ''}
            categories={getCategoriesForRoom(room)}
            isFirstItem={rooms[0].id === room.id}
            isLastItem={rooms[rooms.length - 1].id === room.id}
          />
          ))}
      </div>
      <div className="summary-container">
        {vat.public_prices_enabled !== false && vat.public_prices_total_price_enabled !== false && (
          <div className="total-price-text-container">
            <div className="total-price-text">
              <div className="title">
                {TranslationUtility.GetFormattedMessageForUI('ui-rooms-panel-total-price', 'Precio total')}
              </div>
              <div className="vat">
                {vat.vat_breakdown_disabled
                    ? TranslationUtility.GetFormattedMessageForUI('ui-rooms-panel-including-vat', '(con IVA)')
                    : TranslationUtility.GetFormattedMessageForUI('ui-rooms-panel-excluding-vat', '(sin IVA)')}
              </div>
            </div>
            <div className="total-price-value">{currencyFormatter.format(totalPrice)}</div>
          </div>
        )}
        <button
          type="button"
          className={`summary-button${(vat.public_prices_enabled === false 
            || vat.public_prices_total_price_enabled === false) ? ' public' : ''}`}
          onClick={() => dispatch(changeIsSummaryOpened(true))}
        >
          <span>
            {TranslationUtility.GetFormattedMessageForUI('ui-button-view-summary', 'Ver Resumen')}
          </span>
        </button>
      </div>
      <div className="container-privacy-pages">
        <button
          className="legal-button"
          type="button"
          onClick={() => window.open(legalSettings.legalAdviceUrl)}
        >
          <span>
            {TranslationUtility.GetFormattedMessageForUI('ui-button-legal-advice', 'Aviso Legal')}
          </span>
        </button>
        <div className="separator"> -</div>
        <button
          className="legal-button"
          type="button"
          onClick={() => window.open(legalSettings.privacyPolicyUrl)}
        >
          <span>
            {TranslationUtility.GetFormattedMessageForUI('ui-button-privacy-policy', 'Política de Privacidad')}
          </span>
        </button>
        <div className="separator"> -</div>
        <button
          className="legal-button"
          type="button"
          onClick={() => window.open(legalSettings.cookiesUrl)}
        >
          <span>
            {TranslationUtility.GetFormattedMessageForUI('ui-button-cookies', 'Cookies')}
          </span>
        </button>
      </div>
      <DescriptionPanel />
      <MainMenu />
      {!isSmallScreen() ? <SummaryPanel /> : <SummaryPanelMobile />}
    </div>
);
};

export default RoomsPanel;
